import { render, staticRenderFns } from "./HomepageMobileBuyLeads.vue?vue&type=template&id=973bc638&"
import script from "./HomepageMobileBuyLeads.vue?vue&type=script&lang=js&"
export * from "./HomepageMobileBuyLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports